import { FormFieldInterface } from "../dom";

export class FormField implements FormFieldInterface {
  hide(): void {
    throw new Error("Method not implemented.");
  }
  show(): void {
    throw new Error("Method not implemented.");
  }
  hideOptions(values: string | string[]): void {
    throw new Error("Method not implemented.");
  }
  showOptions(values: string | string[]): void {
    throw new Error("Method not implemented.");
  }
  resetOptions(): void {
    throw new Error("Method not implemented.");
  }
  filterOptions(values: string | string[]): void {
    throw new Error("Method not implemented.");
  }
  clearFilter(): void {
    throw new Error("Method not implemented.");
  }
}
